import * as React from "react";
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 65, height: 1, viewBox: "0 0 65 1", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, width: 64, height: 1, fill: "#D9D9D9" }));
export default SvgRectangle;
